module.exports = __webpack_public_path__ + "static/img/5.5791508.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/5.png
// module id = TECP
// module chunks = 0